import { cn } from '@repo/design-system/lib/utils';
import { Noto_Sans, Noto_Sans_Mono } from 'next/font/google';

/**
 * Typography for the active shadcn preset (b1oZN4Uq): Noto Sans for body text,
 * and headings inherit it (the preset sets `fontHeading: inherit`).
 *
 * `--font-sans` and `--font-mono` are the contract between this file and the
 * theme: `packages/design-system/styles/globals.css` maps them into Tailwind's
 * font utilities via `@theme inline`. Changing the preset's font means
 * swapping the loaders here — nothing else needs to move.
 */
const sans = Noto_Sans({
  subsets: ['latin'],
  variable: '--font-sans',
  display: 'swap',
});

const mono = Noto_Sans_Mono({
  subsets: ['latin'],
  variable: '--font-mono',
  display: 'swap',
});

export const fonts = cn(
  sans.variable,
  mono.variable,
  'touch-manipulation font-sans antialiased'
);
